import React from 'react';
import $ from 'jquery';
import { renderCheckboxList, columnWidth, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import renderForm from './form';
import handleStudyModal from './study';
import {
  renderCaseCustomer,
  onTargetClickAction,
} from 'modules/saas/common/columns';
import { displayCloseCaseModal } from 'modules/saas/pco/interventions/validation/confirm-validation';
import contractFileTableHandler from './contract';
import * as saasEstimates from 'modules/saas/estimates';
import { handleStartDate } from 'modules/saas/pco/cases/organize';

export function contract(ctx) {
  $('.contract.submit.button').on('click', evt => {
    $(':submit').click();
  });

  $('#bt-closenow-case').on('click', evt => {
    const $target = $(evt.currentTarget);
    evt.preventDefault();

    displayCloseCaseModal(() => {
      onTargetClickAction($target, null, 'Error attempting to close case');
    });
  });

  $('#bt-unclose-case').on('click', evt => {
    const $target = $(evt.currentTarget);
    evt.preventDefault();

    onTargetClickAction($target, null, 'Error attempting to unclose case');
  });

  contractFileTableHandler(ctx);

  $('.site_doc_info.help').popup({
    popup: '.site_doc_info.popup',
    on: 'hover',
    position: 'right center',
    lastResort: 'top left',
    offset: 0,
  });

  $('.tech_doc_info.help').popup({
    popup: '.tech_doc_info.popup',
    on: 'hover',
    position: 'right center',
    lastResort: 'top left',
    offset: 0,
  });

  const $form = $('.form');
  handleStartDate($form);
}

export function byEntity(ctx) {
  render('/pco-manager/cases.json', '/pco-manager/cases');
}

export function byCustomer(ctx) {
  const customer = ctx.params.id;
  render(
    `/pco-manager/cases/customer/${customer}/range.json`,
    `/pco-manager/customers/${customer}/cases`
  );
}

export function bySite(ctx) {
  const site = ctx.params.id;
  render(
    `/pco-manager/cases/site/${site}/range.json`,
    `/pco-manager/sites/${site}/cases`
  );
}

export function create() {
  handleForm(undefined, true);
}

export function edit(ctx) {
  const { id } = ctx.params;

  $('#bt-closenow-case').on('click', evt => {
    const $target = $(evt.currentTarget);
    evt.preventDefault();

    displayCloseCaseModal(() => {
      onTargetClickAction($target, null, 'Error attempting to close case');
    });
  });

  $('#bt-unclose-case').on('click', evt => {
    const $target = $(evt.currentTarget);
    evt.preventDefault();

    onTargetClickAction($target, null, 'Error attempting to unclose case');
  });

  handleForm(id);
}

export function estimateList(ctx) {
  const { id } = ctx.params;

  handleStudyModal(id);
  saasEstimates.list(ctx);
}

export function byEntityToOrganize() {
  const referer = '/pco-manager/workflow/cases/toorganize';

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/cases/${id}/organize`, referer);
  const loadNextUrl = '/pco-manager/workflow/cases/toorganize.json';

  renderList(rowClickedUrl, loadNextUrl, renderToOrganizeColumns);
}

export function byEntityStudy() {
  const referer = '/pco-manager/workflow/cases/study';

  const rowClickedUrl = id => withReferer(`/pco-manager/cases/${id}`, referer);
  const loadNextUrl = '/pco-manager/workflow/cases/study.json';

  renderList(rowClickedUrl, loadNextUrl, renderStudyColumns);
}

function handleForm(id, isNew = false) {
  renderForm(id, isNew);
}

function render(url, from) {
  const caseUrl = id => withReferer(`/pco-manager/cases/${id}`, from);

  const rowClickedUrl = id => caseUrl(id);
  const loadNextUrl = url;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}

function renderStatus({ cellData }) {
  let label, title;

  switch (cellData) {
    case 'DEMAND_ONGOING':
      label = 'ui orange labels';
      title = 'Demande en cours';
      break;
    case 'ESTIMATE_TODO':
      label = 'ui orange labels';
      title = 'Devis à Preparer';
      break;
    case 'ESTIMATE_WAITING':
      label = 'ui orange labels';
      title = 'Devis en attente';
      break;
    case 'ESTIMATE_REFUSED':
      label = 'ui grey labels';
      title = 'Devis Refusé';
      break;
    case 'CANCELED':
      label = 'ui grey labels';
      title = 'Supprimé';
      break;
    case 'TO_ORGANIZE':
      label = 'ui orange labels';
      title = 'A organiser';
      break;
    case 'ONGOING':
      label = 'ui green labels';
      title = 'En exécution';
      break;
    case 'TO_REORGANIZE':
      label = 'ui orange labels';
      title = 'A ré-organiser';
      break;
    case 'ENDED':
      label = 'ui grey labels';
      title = 'Terminé';
      break;
    default:
      break;
  }

  if (label && title) {
    return (
      <div className={label}>
        <span className="ui label">{title}</span>
      </div>
    );
  }

  return null;
}

function renderColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={(width / 16) * 4}
      label="Nom du chantier"
    />,
    <Column
      key="work"
      dataKey="work"
      width={columnWidth(width, 4)}
      label="Travaux"
    />,
    <Column
      key="created_at"
      dataKey="created_at"
      width={columnWidth(width, 2)}
      label="Date de création"
    />,
    <Column
      key="last_intervention"
      dataKey="last_intervention"
      width={columnWidth(width, 3)}
      label="Date de dernière intervention"
    />,
    <Column
      key="status"
      dataKey="status"
      cellRenderer={renderStatus}
      width={columnWidth(width, 2)}
      label="Statut"
    />,
  ];
}

function renderToOrganizeActions({ rowData }) {
  const id = rowData.id;

  const onClick = evt => {
    const target = evt.currentTarget;
    evt.preventDefault();
    evt.stopPropagation();

    displayCloseCaseModal(() => {
      onTargetClickAction($(target), id, 'Error attempting to close case');
    });
  };

  const renderButton = (
    <a
      className="ui mini red button icon labeled"
      onClick={onClick}
      data-action={`/pco-manager/cases/${id}/closeFromWorkflow`}
      data-method="PUT"
    >
      <i className="remove icon" />
      Clôturer le chantier
    </a>
  );

  return renderButton;
}

function renderToOrganizeColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={(width / 16) * 4}
      label="Nom du chantier"
    />,
    <Column
      key="sites"
      dataKey="sites"
      width={(width / 16) * 4}
      label="Sites"
    />,
    <Column
      key="worktypes"
      dataKey="worktypes"
      width={(width / 16) * 4}
      label="Travaux"
    />,
    <Column
      key="status"
      dataKey="status"
      cellRenderer={renderStatus}
      width={columnWidth(width, 2)}
      label="Statut"
    />,
    <Column
      key="actions"
      dataKey="id"
      cellRenderer={renderToOrganizeActions}
      width={columnWidth(width, 2.5)}
      label="Actions"
      disableSort
    />,
  ];
}

export const renderStudyStatus = ({ rowData }) => {
  return (
    <span>
      {rowData.status} {rowData.status_date}
    </span>
  );
};

export const renderCaseCreationStep = ({ cellData }) => {
  let label;

  switch (cellData) {
    case 1:
      label = 'Initialisation';
      break;
    case 2:
      label = 'Etude';
      break;
    case 3:
      label = 'Chantier';
      break;
    case 4:
      label = 'Devis';
      break;
    default:
      break;
  }

  if (label) {
    return <span>{label}</span>;
  }

  return null;
};

function renderStudyColumns(width) {
  return [
    <Column
      key="name"
      dataKey="name"
      cellRenderer={renderCaseCustomer}
      width={columnWidth(width, 4)}
      label="Nom du chantier"
    />,
    <Column
      key="step"
      dataKey="step"
      cellRenderer={renderCaseCreationStep}
      width={columnWidth(width, 3)}
      label="Etape"
    />,
    <Column
      key="status"
      dataKey="status"
      width={columnWidth(width, 5)}
      cellRenderer={renderStudyStatus}
      label="Etude"
    />,
    <Column
      key="created_at"
      dataKey="created_at"
      width={columnWidth(width, 4)}
      label="Date de création"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/index.js